<template>
  <div class="po-form">
    <div class="po-form__header">
      <a href="/"><img src="../assets/img/logo.svg" alt="logo"></a>
      <a
        class="po-form__back-link"
        v-bind:href="this.$parent.mainSiteURL"
      >
        Вернуться на сайт
      </a>
    </div>
    <div class="po-form__title">Регистрация</div>
    <!--
    <div class="form__row">
      <div
        class="po-form__control"
        v-bind:class="{
          'po-form__control_conformed': !$v.registrationForm.username.$invalid || (formErrors.username && formErrors.username.length),
          'po-form__control_rejected': $v.registrationForm.username.$error
        }"
      >
        <label class="po-form__label" for="username">Имя пользователя</label>
        <input
          type="text" class="po-form__input" id="username"
          v-model="$v.registrationForm.username.$model"
        >
        <div
          class="po-form__error"
          v-if="$v.registrationForm.username.$dirty && !$v.registrationForm.username.required"
        >
          Это поле необходимо заполнить
        </div>
        <template v-if="formErrors.username">
          <div
            class="po-form__error"
            v-for="(error, index) in formErrors.username"
            v-bind:key="'username' + index"
          >
            {{ error }}
          </div>
        </template>
      </div>
    </div>
    -->
    <div class="form__row form__row_mt-50">
      <div
        class="po-form__control"
        v-bind:class="{
          'po-form__control_conformed': !$v.registrationForm.first_name.$invalid,
          'po-form__control_rejected': $v.registrationForm.first_name.$error
        }"
      >
        <label class="po-form__label" for="first-name">Имя</label>
        <input
          type="text" class="po-form__input" id="first-name"
          v-model="$v.registrationForm.first_name.$model"
        >
        <div
          class="po-form__error"
          v-if="$v.registrationForm.first_name.$dirty && !$v.registrationForm.first_name.required"
        >
          Это поле необходимо заполнить
        </div>
      </div>
    </div>
    <div class="form__row">
      <div
        class="po-form__control"
        v-bind:class="{
          'po-form__control_conformed': !$v.registrationForm.last_name.$invalid,
          'po-form__control_rejected': $v.registrationForm.last_name.$error
        }"
      >
        <label class="po-form__label" for="last-name">Фамилия</label>
        <input
          type="text" class="po-form__input" id="last-name"
          v-model="$v.registrationForm.last_name.$model"
        >
        <div
          class="po-form__error"
          v-if="$v.registrationForm.last_name.$dirty && !$v.registrationForm.last_name.required"
        >
          Это поле необходимо заполнить
        </div>
      </div>
    </div>
    <div class="form__row">
      <div
        class="po-form__control"
        v-bind:class="{
          'po-form__control_conformed': ($v.registrationForm.email.$dirty && !$v.registrationForm.email.$error) || (formErrors.email && formErrors.email.length),
          'po-form__control_rejected': $v.registrationForm.email.$error
        }"
      >
        <label class="po-form__label" for="email">Email</label>
        <input
          type="text" class="po-form__input" id="email"
          v-model="$v.registrationForm.email.$model"
        >
        <div
          class="po-form__error"
          v-if="$v.registrationForm.email.$dirty && !$v.registrationForm.email.required"
        >
          Это поле необходимо заполнить
        </div>
        <div
          class="po-form__error"
          v-if="$v.registrationForm.email.$dirty && $v.registrationForm.email.required && !$v.registrationForm.email.email"
        >
          Введите корректный email
        </div>
        <template v-if="formErrors.email && $v.registrationForm.email.required && $v.registrationForm.email.email">
          <div
            class="po-form__error"
            v-for="(error, index) in formErrors.email"
            v-bind:key="'email' + index"
          >
            {{ error }}
          </div>
        </template>
      </div>
    </div>
    <div class="form__row">
      <div class="po-form__control">
        <label class="po-form__label" for="city">Город</label>
        <input type="text" class="po-form__input" id="city">
      </div>
    </div>
    <div class="form__row">
      <div class="po-form__control">
        <label class="po-form__label" for="street">Улица</label>
        <input type="text" class="po-form__input" id="street">
      </div>
    </div>
    <div class="form__row form__row_between">
      <div class="po-form__control po-form__control_half">
        <label class="po-form__label po-form__label_auto" for="house">Дом</label>
        <input type="text" class="po-form__input po-form__input_auto" id="house">
      </div>
      <div class="po-form__control po-form__control_half">
        <label class="po-form__label po-form__label_auto" for="room">Квартира/Офис</label>
        <input type="text" class="po-form__input po-form__input_auto" id="room">
      </div>
    </div>
    <div class="form__row">
      <div class="po-form__control">
        <label class="po-form__label" for="phone">Телефон</label>
        <vue-mask 
          class="po-form__input"
          id="phone"
          name="phone"
          v-model="$v.registrationForm.phone.$model"  
          mask="+ZZ 000 000 00 ZZ" 
          :raw="false"
          :options="phoneMaskOptions"
        >
        </vue-mask>
        <div
          class="po-form__error"
          v-if="$v.registrationForm.phone.$dirty && !$v.registrationForm.phone.required"
        >
          Это поле необходимо заполнить
        </div>
        <div
          class="po-form__error"
          v-if="$v.registrationForm.phone.$dirty && $v.registrationForm.phone.required && !$v.registrationForm.phone.customPhone"
        >
          Введите корректный номер телефона
        </div>
      </div>
    </div>
    <div class="form__row form__row_no-flex">
      <div class="po-form__control">
        <label class="po-form__label" for="password">Пароль</label>
        <input
          type="password" class="po-form__input" id="password"
          v-model="$v.registrationForm.password.$model"
        >
        <div
          class="po-form__error"
          v-if="$v.registrationForm.password.$dirty && !$v.registrationForm.password.minLength"
        >
          Пароль должен содержать минимум 8 символов
        </div>
        <div
          class="po-form__error"
          v-if="$v.registrationForm.password.$dirty && $v.registrationForm.password.minLength && !$v.registrationForm.password.strongPassword"
        >
          Пароль должен содержать минимум 1 букву и 1 цифру
        </div>
      </div>
      <div class="po-form__notice">минимум одна цифра, минимум одна буква, не меньше 8 символов</div>
    </div>
    <div class="form__row">
      <div
        class="e-button"
        @click="submit"
      >
        Зарегистрироваться
      </div>
    </div>
    <div class="form__row">
      <div class="form__policy" v-if="this.$parent.config" v-html="this.$parent.config.form_politics">
      </div>
    </div>
  </div>
</template>

<script>

import { required, email } from 'vuelidate/lib/validators'

import { User } from '@/api/user';

export default {
  name: 'registration',
  data: function() {
    return {
      registrationForm: {
        first_name: null,
        last_name: null,
        email: null,
        city: null,
        street: null,
        house: null,
        flat: null,
        phone: null,
        password: null,
      },
      phoneMaskOptions: {
        translation: {
          'Z': {
            pattern: /[0-9]/,
            optional: true
          },
        }
      },
      formErrors: {},
    }
  },
  validations: {
    registrationForm: {
      first_name: {
        required,
      },
      last_name: {
        required
      },
      phone: {
        required,
        customPhone: (value) => /\+[0-9]{10,12}/.test(value.replace(/[\s\-()]/g, ''))
      },
      email: {
        required,
        email
      },
      password: {
        minLength: (value) => !!value && value.length >= 8,
        strongPassword: (value) => !!value && /\d/.test(value) && /[a-zA-Z]/.test(value)
      },
    }
  },
  methods: {
    submit: function (){
      this.formErrors = {};
      this.$v.$touch();
      if(!this.$v.$invalid) {
        User.create(this.registrationForm).then(response => {
          if (response.status == 201) {
            this.$router.push('login');
          } else if(response.status == 400) {
            this.formErrors = response.data;
          }
        });
      }
    },
  },
}
</script>